import { useCalendar } from "Components/Common/hooks/useCalendar";
import { useCompany } from "Components/Company/hooks/useCompany";
import { CollectionPath, db } from "Configs/firebase";
import { createCollectionStore } from "Store/helpers/createCollectionStore";
import { ScheduleEntry, isScheduleEntry } from "domain-entities";
import { collection } from "firebase/firestore";
import { useEffect, useState } from "react";
import moment from "moment";
import { CalendarType } from "Components/Navigation/NavigationHelper";

export const useDayScheduleEntries = createCollectionStore<ScheduleEntry>({
  is: isScheduleEntry,
  sort: (a: ScheduleEntry, b: ScheduleEntry) => a.startTime - b.startTime,
});

export const useSubscribeToDayScheduleEntries = () => {
  const selectedDate = useCalendar((state) => state.selectedDate);
  const calendarType = useCalendar((state) => state.calendarType);
  const [earliestDay, setEarliestDay] = useState(selectedDate.clone().startOf('day'));
  const companyId = useCompany((state) => state.item?.id);

  // Only update earliest day if in day view and navigating to earlier date
  useEffect(() => {
    if (calendarType === CalendarType.DAY && selectedDate.isBefore(earliestDay)) {
      setEarliestDay(selectedDate.clone().startOf('day'));
    }
  }, [selectedDate, earliestDay, calendarType]);

  useEffect(() => {
    // No-op if not in day view
    if (!companyId || calendarType !== CalendarType.DAY) return;

    const ref = collection(
      db,
      CollectionPath.SCHEDULES,
      companyId,
      CollectionPath.SCHEDULE_ENTRIES
    );

    // Query for entries that end after the earliest viewed day
    // This ensures we get entries that might start before but extend into our day
    return useDayScheduleEntries
      .getState()
      .subscribe(ref, [["endTime", ">", earliestDay.unix()]]);
  }, [companyId, earliestDay.unix(), calendarType]);

  useEffect(() => {
    return useDayScheduleEntries.getState().reset;
  }, []);
}; 